/* ActivityViewComponent.js */

"use strict";
const _ = require("lodash");
const ActivityTypeColumn = require("./column_renderers/activity_type/ActivityTypeComponent");
const SnapshotColumn = require("./column_renderers/snapshot/SnapshotComponent");
const DescriptionColumn = require("./column_renderers/description/DescriptionComponent");
const StatusColumn = require("./column_renderers/status/StatusComponent");
const ActionsColumn = require("./column_renderers/actions/ActionsComponent");
const BaseActivityViewComponent = require("../../../../lib/activity/BaseActivityViewComponent");

const Renderer = require("./ActivityViewRenderer");
const uString = require("underscore.string");

const PagingActivityFeed = require("./PagingActivityFeed");

_.mixin(uString.exports());

class ActivityViewComponent extends BaseActivityViewComponent {
    constructor(logger, gameEditor, io, utils, userSession, solutionsManager, storageFactory) {
        super(logger, gameEditor, io, utils, userSession, solutionsManager, storageFactory);

        this.columnConfig = {
            activityType: {
                label: "Type",
                columnRendererComponent: ActivityTypeColumn,
                entityColumn: true,
                sortable: false,
                resizable: false,
                width: 50,
                priority: 1
            },
            snapshot: {
                sort: "desc",
                label: "Activity On",
                entityColumn: true,
                columnRendererComponent: SnapshotColumn,
                sortable: true,
                width: 170,
                priority: 2
            },
            description: {
                label: "Description",
                entityColumn: true,
                columnRendererComponent: DescriptionColumn,
                sortable: false,
                width: 300,
                priority: 3
            },
            status: {
                label: "Status",
                entityColumn: true,
                columnRendererComponent: StatusColumn,
                sortable: false,
                width: 60,
                priority: 4
            },
            actions: {
                label: "",
                columnRendererComponent: ActionsColumn,
                shown: true,
                entityColumn: true,
                sortable: false,
                resizable: false,
                width: 50,
                priority: 5
            }
        };

        this._renderer = new Renderer(this);
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/

    _patchSorting(sorting) {
        let patchedSorting = _.clone(sorting);
        patchedSorting.createdOn = patchedSorting.snapshot || -1;
        return patchedSorting;
    }

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC COMPONENT MODEL METHODS    */
    /*******************************************/

    shutdown() {
        return super.shutdown().then(
            () => {
                this._renderer = undefined;
                this.columnConfig = undefined;
            },
            (err) => {
                this._logger.warn({ error: err }, "ActivityViewComponent.shutdown() error.");
            }
        );
    }

    whenModelIsReady() {
        return this._gameEditor.whenEditorIsReady().then(() => {
            const userSorting = this._userGridData.getSorting() || {};
            const patchedSort = this._patchSorting(userSorting);
            this._entity = this._gameEditor.getOsImage();
            this._activityFeed = new PagingActivityFeed({
                feedKey: this._gridKey + "_feed",
                userSession: this._userSession,
                entityDef: this._entity,
                columnConfig: this.columnConfig,
                additionalDataFields: ["createdOn", "createdBy", "patch", "before", "relName"],
                sort: patchedSort
            });
            this._registerListeners();
            return this.whenFeedIsReady();
        });
    }

    whenFeedIsReady() {
        return this._activityFeed.whenFeedReady().catch((err) => {
            this._logger.warn({ error: err }, "PagingActivityFeed.whenFeedReady() error.");
        });
    }

    /*******************************************/
    /* END COMPONENT MODEL METHODS             */
    /* START HANDLER METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE METHODS                     */
    /* START PUBLIC API METHODS                */
    /*******************************************/

    /*******************************************/
    /* END PUBLIC API METHODS                  */
    /*******************************************/
}

module.exports = ActivityViewComponent;

ActivityViewComponent.$inject = [
    "$teve.logger",
    "gameEditor.gameEditor",
    "$teve.io",
    "$teve.utils",
    "$teve.userSession",
    "$teve.solutionsManager",
    "$teve.storageFactory"
];

ActivityViewComponent.$displayDetails = {
    type: "View",
    name: "Activities",
    icon: "configdrift.activity",
    shown: true,
    title: "Activities",
    order: 5
};
